module.exports = __webpack_public_path__ + "img/time.21bf1df1.svg";